import { Environment } from 'environment.js'
import { useSelector } from 'Flux/index.js'
import type { State } from 'Flux/Slice/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { testOrdersWithCounts } from 'View/Page/OrderManagementPage/IOrder.stub.js'

export const useGetAllOrders = () => {
  return {
    orders: useSelector(getAllOrders),
    total: useSelector(getTotalOrders)
  }
}

export const getAllOrders = (state: typeof State) =>
  Environment.DEV_SKIP_LOGIN === 'true' && Environment.ENVIRONMENT === 'development' ? testOrdersWithCounts : state[orderSlice.name].orders
export const getTotalOrders = (state: typeof State) =>
  Environment.DEV_SKIP_LOGIN === 'true' && Environment.ENVIRONMENT === 'development'
    ? testOrdersWithCounts.length
    : state[orderSlice.name].total
